
import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/RedboxIndices.css';

const RedboxIndices = () => {
  return (
    <>
      <Helmet>
        <title>Redbox Indices - Market Indices & Benchmark Solutions | Redbox Global</title>
        <meta
          name="description"
          content="Redbox Indices offers real-time market indices, benchmarks, and analytics for investors and financial institutions."
        />
        <meta
          name="keywords"
          content="Redbox Indices, market indices, financial benchmarks, market analytics, investment indices, financial data"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/indices" />
        <meta property="og:title" content="Redbox Indices - Market Benchmark Platform" />
        <meta
          property="og:description"
          content="Track market indices and benchmarks with Redbox Indices platform for accurate financial data and analytics."
        />
        <meta
          property="og:image"
          content="https://images.unsplash.com/photo-1581091870626-0bcd636ed0e8?w=1200&h=630&fit=crop"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Redbox Indices - Market Benchmark Platform" />
        <meta
          name="twitter:description"
          content="Professional-grade market indices, benchmark tracking, and financial analytics."
        />
        <meta
          name="twitter:image"
          content="https://images.unsplash.com/photo-1581091870626-0bcd636ed0e8?w=1200&h=630&fit=crop"
        />

        <link rel="canonical" href="https://redboxglobal.com/indices" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FinancialProduct",
            "name": "Redbox Indices",
            "category": "FinancialMarketData",
            "description":
              "Platform providing real-time market indices, benchmarks, and analytics for investors.",
            "url": "https://redboxglobal.com/indices",
            "provider": {
              "@type": "Organization",
              "name": "Redbox Global"
            }
          })}
        </script>
      </Helmet>

      <div className="page-container">
        <div className="page-header">
          <h1>Redbox Indices</h1>
          <p className="page-subtitle">
            Real-time market indices, benchmarks, and analytics for informed investing
          </p>
        </div>

        <div className="page-content">
          {/* Featured Article */}
          <a
            href="/article/redbox-indices-overview"
            style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
          >
            <div className="featured-article">
              <div className="featured-image">
                <img
                  src="https://images.unsplash.com/photo-1581091870626-0bcd636ed0e8?w=1200&h=600&fit=crop"
                  alt="Market indices dashboard"
                />
              </div>
              <div className="featured-content">
                
                <h2>Track Market Indices with Accuracy and Insights</h2>
                <p>
                  Redbox Indices provides reliable, real-time market data, benchmarks, and
                  analytics to help investors and financial institutions make informed
                  decisions.
                </p>
                <span className="article-meta">Explore Indices</span>
              </div>
            </div>
          </a>

          {/* Article Cards */}
          <div className="content-grid">
            <a
              href="/article/equity-indices"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=400&fit=crop"
                    alt="Equity indices"
                  />
                </div>
                <div className="article-content">
                  
                  <h2>Global Equity Indices</h2>
                  <p>
                    Access real-time equity indices across global markets with performance analytics.
                  </p>
                  <span className="article-meta">View Equities</span>
                </div>
              </article>
            </a>

            <a
              href="/article/fixed-income-indices"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=600&h=400&fit=crop"
                    alt="Fixed income indices"
                  />
                </div>
                <div className="article-content">
                 
                  <h2>Bond & Fixed Income Indices</h2>
                  <p>
                    Monitor bond markets and fixed income benchmarks for risk-adjusted performance.
                  </p>
                  <span className="article-meta">View Fixed Income</span>
                </div>
              </article>
            </a>

            <a
              href="/article/commodity-indices"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1573164574236-c1d6bcd69e22?w=600&h=400&fit=crop"
                    alt="Commodity indices"
                  />
                </div>
                <div className="article-content">
                 
                  <h2>Commodity & Energy Indices</h2>
                  <p>
                    Track commodity and energy benchmarks with accurate and timely data.
                  </p>
                  <span className="article-meta">View Commodities</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default RedboxIndices;
